module.exports = function (filter) {
    var filterDiv = $(filter).closest('.news-landing-filters');

    var newsLandingList = $(filterDiv).siblings().filter('.news-landing-list');
    var query = '?Page=0';

    var contextItemId = $(filterDiv).data('contextitemid');
    if (contextItemId !== '') {
        query = query + '&ContextItemId=' + contextItemId;
    }

    var newsCategories = $(filterDiv).find('#newsCategories').children().filter(':selected').val();
    if (newsCategories !== '') {
        query = query + '&Categories=' + encodeURIComponent(newsCategories);
    }

    var newsArticleType = $(filterDiv).find('#newsTypes').children().filter(':selected').val();
    if (newsArticleType !== '') {
		query = query + '&Type=' + encodeURIComponent(newsArticleType);
    }

    var url = '/api/news/search' + query;
    $.ajax({
        url: url,
        success: function (data) {
            if (data.length > 0) {
                $(newsLandingList).replaceWith(data);
            } else {
                $(newsLandingList).html('');
            }

            var queryParms = query.split('&');
            for (var i = 0; i < queryParms.length; i++) {
                if (queryParms[i].startsWith("ContextItemId")) {
                    queryParms.splice(i, 1);
                }
            }
            query = queryParms.join('&');
            window.history.replaceState({}, null, window.location.pathname + query);
        },
        error: function () {
            console.log('Failed to filter news items.');
        }
    });
}
